import React from 'react';

/** The chat-owned panel element, independent of message focus or A2UI markup. */
export const ChatPanelContext: React.Context<HTMLElement | null> =
	React.createContext<HTMLElement | null>(null);
